"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HeadlineSkeleton;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@linaria/core");
var _commonStyles = require("../styles/commonStyles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const lockupClassName = "ly8veot";
function HeadlineSkeleton(_ref) {
  let {
    className
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _core.cx)(lockupClassName, className)
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)(_commonStyles.skeletonTextRow, _commonStyles.skeletonAnimatedBg, 'skeletonHeading')
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)(_commonStyles.skeletonTextRow, _commonStyles.skeletonAnimatedBg, 'skeletonHeading')
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "skeletonCtas"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)(_commonStyles.skeletonTextRow, _commonStyles.skeletonAnimatedBg, 'skeletonCta')
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)(_commonStyles.skeletonTextRow, _commonStyles.skeletonAnimatedBg, 'skeletonCta')
  })));
}
HeadlineSkeleton.propTypes = {
  className: _propTypes.default.string
};